module.exports = __webpack_public_path__ + "img/img_quilt03@3x.1a044651.png";